import { useEffect, useState } from "react";
import RequestItem from "./Panels/RequestItem";
import AppService from "../../../../Configurations/Appservice";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import { Typography } from "@mui/material";

const { Box } = require("@mui/system");

const DATA = [{}, {}, {}];
const TopupRequest = (props) => {
  const [requests, setRequests] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Payment Approval"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    dispatch(showLoader());
    AppService.get("v1/topupRequest/pending")
      .then((response) => {
        setRequests(response);
        setIsEmpty(response.length === 0);
      })
      .catch((error) => {
        alert("something went wrong");
      })
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, []);

  const _removeItem = (id) => {
    let requestCopy = [...requests];
    requestCopy = requestCopy.filter((item) => item.id !== id);
    setRequests(requestCopy);
  };

  return (
    <Box p={1}>
      {isEmpty && <Typography>No Pending Request</Typography>}
      {requests.map((item, index) => (
        <RequestItem key={item.id} item={item} index={index} removeItem={_removeItem} />
      ))}
    </Box>
  );
};

export default TopupRequest;
